export const PATHS = {
  UNIVERSAL_LINKS_LIST: '/universal-links',
};
